var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",staticClass:"reply-placeholder-text-field js-vue-discussion-reply",attrs:{"rows":"1","placeholder":_vm.placeholderText,"aria-label":_vm.labelText},on:{"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }